import { defineMessages, IntlShape } from "react-intl";

import { showModal } from "@mapmycustomers/ui";

const messages = defineMessages({
  changeToToday: {
    id: "deal.showClosingDateAlert.changeToToday",
    defaultMessage: "Yes, change to today",
    description: "Change to today",
  },
  description: {
    id: "deal.showClosingDateAlert.description",
    defaultMessage: "This will overwrite any existing date you have entered previously. ",
    description: "Deal Close Date Alert description",
  },
  keepSame: {
    id: "deal.showClosingDateAlert.keepSame",
    defaultMessage: "No, keep the same",
    description: "Keep same closing date",
  },
  title: {
    id: "deal.showClosingDateAlert.title",
    defaultMessage: "Would you like to change the close date to today’s date?",
    description: "Deal Close Date Alert title",
  },
});

const showClosingDateAlert = (onConfirm: () => void, onCancel: () => void, intl: IntlShape) => {
  showModal({
    cancelText: intl.formatMessage(messages.keepSame),
    content: intl.formatMessage(messages.description),
    okText: intl.formatMessage(messages.changeToToday),
    onCancel,
    onOk: onConfirm,
    title: intl.formatMessage(messages.title),
    type: "confirm",
  });
};

export default showClosingDateAlert;
